module.exports = __webpack_public_path__ + "static/img/47173.2a9973e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/47173.jpg
// module id = 432
// module chunks = 6